import { useEffect, useMemo, useState } from "react";
import { Dialog } from "primereact/dialog";
import Button from "../../componentes/button/button";
import TabelaRetornosDeEntregas from "./escala-de-rotas/TabelaRetornosDeEntregas";
import { CustomTable } from "../../componentes/table/CustomTable";
import RomaneioService from "../../services/resource/romaneioService";
import { toast } from "react-toastify";
import { capitalizeNome } from "../../utils/reduzirNome";
import { formatLocalDate } from "../../utils/formatDate";
import DiasTrabalhados from "./DiasTrabalhados";
import CadastrarAjusteComissao from "./ajustes/CadastrarAjuste";

function TabelaRomaneios({ ano, mes, funcionarioId, filialId }) {
    const romaneioService = new RomaneioService();

    const [modalDeRetornos, setModalRetornos] = useState(false);
    const [selectedCarga, setSelectedCarga] = useState(null);
    const [loading, setLoading] = useState(false);
    const [mostrarDiasTrabalhados, setMostrarDiasTrabalhados] = useState(false);
    const [data, setData] = useState(null);
    const [modalAjuste, setModalAjuste] = useState(false);
    const [romaneioAjuste, setRomaneioAjuste] = useState(null);

    useEffect(() => {
        if (ano && mes) {
            buscarRomaneios();
        }
    }, [ano, mes, funcionarioId]);

    const dadosFiltrados = useMemo(() => data ?? [], [data]);

    const buscarRomaneios = () => {
        setLoading(true);
        romaneioService.listar(funcionarioId, ano, mes, filialId).then(res => {
            setData(res.data);
            setLoading(false);
        })

    }
    const formatNumber = (v) =>
        v != null ? Number(v).toLocaleString("pt-BR") : "—";

    const columns = useMemo(() => [

        // { key: "filialNome", label: "Filial", sortable: true, width: 140 },

        {
            key: "id",
            label: "Romaneio",
            sortable: true
        },


        {
            key: "dataEmissao",
            label: "Data de Emiss.",
            sortable: true,
            render: v => formatLocalDate(v)
        },

        {
            key: "dataAcerto",
            label: "Data Acert.",
            sortable: false,
            render: v => formatLocalDate(v)
        },

        {
            key: "quantidadeDiasUteisFechamento",
            label: "Dias",
            sortable: false
        },

        {
            key: "prazo",
            label: "Status",
            sortable: false,
            render: (v, row) => {
                const classes = {
                    "No Prazo": "bg-success text-success-foreground",
                    "Fora do Prazo": "bg-destructive text-destructive-foreground",
                    "Indefinido": "bg-gray-500 text-white",
                    "Ajustado": "bg-blue-500 text-white",
                    "Ajuste Solicitado":"bg-yellow-500 text-white"

                };

                const labels = {
                    "No Prazo": "No Prazo",
                    "Fora do Prazo": "Fora do Prazo",
                    "Indefinido": "Indefinido",
                    "Ajustado": "Ajustado",
                    "AJUSTE_SOLICITADO":"Ajuste Solicitado"
                };

                return (
                    <div className="flex items-center gap-2">
                        <span
                            className={`py-1 px-2 rounded-lg font-medium ${classes[v] ?? "bg-muted text-muted-foreground"
                                }`}
                        >
                            {labels[v] ?? v}
                        </span>

                        {v === "Fora do Prazo" && (
                            <button
                                type="button"
                                title="Solicitar ajuste"
                                onClick={() => {
                                    setRomaneioAjuste(row);
                                    setModalAjuste(true);
                                }}
                                className="text-primary hover:brightness-90 transition-colors duration-150"
                            >
                                <i className="fa fa-wrench" />
                            </button>
                        )}
                    </div>
                );
            },
        },
        {
            key: "placa",
            label: "Placa",
            sortable: false
        },

        {
            key: "motoristaNome", label: "Motorista",
            render: (item) => capitalizeNome(item),
            sortable: true
        },

        {
            key: "auxiliar1Nome",
            label: "Auxiliar 1",
            render: (item) => capitalizeNome(item)
        },

        {
            key: "auxiliar2Nome",
            label: "Auxiliar 2",
            render: (item) => capitalizeNome(item)
        },

        {
            key: "quantidadePedidos", label: "QTD Ped.", sortable: true, render: (row) => (
                <span
                    onClick={(e) => {
                        toast.warn("Função ainda não implementada.")
                    }}
                    className="underline text-primary cursor-pointer hover:brightness-90 transition-colors duration-150"
                >
                    {row}
                </span>
            )
        },

        { key: "quantidadeEntregas", label: "QTD Ent.", sortable: true },

        {
            key: "cubosEntregue",
            label: "Cubagem",
            center: true,
            sortable: true,
            render: v => formatNumber(v)
        },
        {
            key: "cubosDevolvido",
            label: "Cubos Dev.",
            center: true,
            sortable: true,
            render: v => formatNumber(v)
        },

        {
            key: "caixasEntregue",
            label: "Cxs Entr.",
            center: true,
            sortable: true,
            render: v => formatNumber(v)
        },

        {
            key: "caixasDevolvida",
            label: "Cxs Dev.",
            center: true,
            sortable: true,
            render: v => formatNumber(v)
        },
        {
            key: "codigoMotoristaSnapshot", label: "Cód Mot (BI)",
            sortable: true
        },

        {
            key: "codigoAjudante1Snapshot",
            label: "Cód Aux1 (BI)",
            sortable: true
        },

        {
            key: "codigoAjudante2Snapshot",
            label: "Cód Aux2 (BI)",
            sortable: true
        },
    ], [dadosFiltrados]);

    const footer = () => {
        const totais = dadosFiltrados.reduce(
            (acc, row) => ({
                caixasEntregue: acc.caixasEntregue + (Number(row.caixasEntregue) || 0),
                caixasDevolvida: acc.caixasDevolvida + (Number(row.caixasDevolvida) || 0),
                cubosEntregue: acc.cubosEntregue + (Number(row.cubosEntregue) || 0),
                cubosDevolvido: acc.cubosDevolvido + (Number(row.cubosDevolvido) || 0),
                quantidadeEntregas: acc.quantidadeEntregas + (Number(row.quantidadeEntregas) || 0),
                quantidadePedidos: acc.quantidadePedidos + (Number(row.quantidadePedidos) || 0),
            }),
            {
                caixasEntregue: 0,
                caixasDevolvida: 0,
                cubosEntregue: 0,
                cubosDevolvido: 0,
                quantidadeEntregas: 0,
                quantidadePedidos: 0,
            }
        );

        return (
            <div className="flex flex-wrap justify-between gap-2 p-2 text-[11px] border-t border-border bg-muted">
                <div className="font-semibold">
                    Total de Cargas: {dadosFiltrados.length}
                </div>
                <div className="flex flex-wrap gap-4">
                    <span><span className="font-semibold">QTD Ped.:</span> {formatNumber(totais.quantidadePedidos)}</span>
                    <span><span className="font-semibold">QTD Ent.:</span> {formatNumber(totais.quantidadeEntregas)}</span>
                    <span><span className="font-semibold">Cubagem:</span> {formatNumber(totais.cubosEntregue)}</span>
                    <span><span className="font-semibold">Cubagem de Retorno.:</span> {formatNumber(totais.cubosDevolvido)}</span>
                    <span><span className="font-semibold">Cxs Entregues.:</span> {formatNumber(totais.caixasEntregue)}</span>
                    <span><span className="font-semibold">Cxs Dev.:</span> {formatNumber(totais.caixasDevolvida)}</span>
                </div>
            </div>
        );
    };

    return (
        <div>

            <CustomTable
                data={dadosFiltrados}
                columns={columns}
                loading={loading}
                maxHeight="calc(100vh - 255px)"
                footer={footer}
                className="text-[11px]"
                showHeader={false}
                header={<div className="px-2 py-1 bg-muted hover:bg-muted/70 transition-colors duration-150 cursor-pointer rounded-md my-1" onClick={() => setMostrarDiasTrabalhados(true)}>
                    Ver dias trabalhados
                </div>}
            />

            <Dialog
                visible={modalDeRetornos}
                onHide={() => setModalRetornos(false)}
                className="w-[95%]"
                blockScroll
                contentClassName="p-0"
                footer={
                    <div className="flex justify-end pt-3">
                        <Button
                            variant="gray"
                            label="Voltar"
                            iconLeft="fa fa-arrow-left"
                            onClick={() => setModalRetornos(false)}
                        />
                    </div>
                }
            >
                <TabelaRetornosDeEntregas values={selectedCarga} />
            </Dialog>

            <Dialog
                header="Dias Trabalhados"
                visible={mostrarDiasTrabalhados}
                onHide={() => setMostrarDiasTrabalhados(false)}
                className="w-[80%]"
            >
                <DiasTrabalhados ano={ano} mes={mes} />
            </Dialog>

            <Dialog
                header={
                    <div className="flex items-center gap-2 text-base font-bold text-foreground">
                        <i className="fa fa-wrench text-primary" />
                        Solicitar Ajuste
                    </div>
                }
                blockScroll
                visible={modalAjuste}
                onHide={() => setModalAjuste(false)}
                className="w-[80%]"
            >
                <CadastrarAjusteComissao
                    ano={ano}
                    mes={Number(mes)}
                    onClose={() => setModalAjuste(false)}
                    onSuccess={() => {
                        setModalAjuste(false);
                        buscarRomaneios();
                    }}
                    defaultValues={{
                        filialId: Number(romaneioAjuste?.filialId) ?? null,
                        transporte: romaneioAjuste?.id ?? ""
                    }}
                    camposDesabilitados={["ano", "mes", "filialId", "transporte"]}
                />
            </Dialog>

        </div>
    );
}

export default TabelaRomaneios;